var App = App || {};

App.Login = (() => {
    const form = document.getElementById('login-form');

    const init = () => {
        let savedId = App.Cookies.getItem('OnlineBankingUserID');
        if (savedId) {
            document.getElementById('userid').value = App.Cookies.getItem('OnlineBankingUserID');
            document.getElementById('rememberUserid').checked = true;
        }

        form.addEventListener('submit', rememberMe);
    };

    const rememberMe = () => {
        const rememberUserid = document.getElementById('rememberUserid');
        const userid = document.getElementById('userid').value;

        if (rememberUserid.checked && userid) {
            //set cookie
            App.Cookies.setItem(
                `OnlineBankingUserID`,
                userid,
                new Date().getDate() + 30,
                '/',
                window.location.hostname,
                window.location.protocol === 'https:'
            );
        }
        else {
            //unset cookie
            App.Cookies.removeItem(
                'OnlineBankingUserID',
                '/',
                window.location.hostname
            );
        }
    };

    return {
        init
    };
})();